import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function AutumnRe({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2

  //questions section
  var questionsY1Autumn = [];
  questionsY1Autumn.push({ "question" : "What number is missing? ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What is one more than 6?", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What is one less than 9?", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Emile has 4 gems. He buys the gems below. How many gems does he have? ", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Aimee has made a number. What number has Aimee made? ", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Scrambler has made a number. What number has Scrambler made? ", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Emile has made a number. What number has Emile made? ", "answer" : "14", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Here is a number line. What number is A? ", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Write the number 13 in words. ", "answer" : "Thirteen|Fifteen|Thirty", "type": 1, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What type of shape is this? ", "answer" : "Triangle|Square|Circle", "type": 1, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What does this symbol mean? ", "answer" : "More than|Less than |Equal to", "type": 1, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What is the missing number? ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "What is the missing number? ", "answer" : "6", "type": 0, "units" : "", "marks" : 1})



  var questionsY2Autumn = [];
  questionsY2Autumn.push({ "question" : "What is the number 13 as a word? ", "answer" : "thirteen|twelve|fifteen", "type": 1, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Emile is counting in steps of 10. He starts at 5. Which number will he say? ", "answer" : "65|42|30", "type": 1, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Emile has made a number. What number has he made? ", "answer" : "22", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Scrambler has made a number. What number has he made? ", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "What is double 11?", "answer" : "22", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Aimee has some coins. How much money does Aimee have? ", "answer" : "37", "type": 0, "units" : "p", "marks" : 1})
questionsY2Autumn.push({ "question" : "Emile buys gems in boxes of 10. How many gems has Emile bought?", "answer" : "50", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Scrambler and Aimee buy some gems. How many more gems has Aimee bought than Scrambler? ", "answer" : "31", "type": 0, "units" : "gems", "marks" : 1})
questionsY2Autumn.push({ "question" : "Here is an array. Which multiplication fact does the array show? ", "answer" : "7 x 3 = 21|6 x 4 = 24|6 x 3 = 18", "type": 1, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Here is a part whole model. What number is missing? ", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Here is a number line from 0 to 20. What number is A? ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Emile has £1.17. Some of his money is shown. What coins are missing? ", "answer" : "10p and 2p coins|£1 and 5p coins |10p and 5p coins", "type": 1, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "Scrambler buys a pack of 10 gems and 2 gems on their own for £13. 1 gem costs £1.50. How much is a pack of 10 gems?", "answer" : "10", "type": 0, "units" : "£", "marks" : 1})
questionsY2Autumn.push({ "question" : "Emile, Scrambler and Aimee have 62 gems altogether. Emile has 24 gems. Aimee has 26 gems. How many gems does Scrambler have?", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})


  var questionsY3Autumn = [];
  questionsY3Autumn.push({ "question" : "Scrambler has made a number. What number has he made? ", "answer" : "Four hundred and sixty-five|Four hundred and fifty-five|Four hundred and thirty-five", "type": 1, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Emile has made a number. What number has he made? ", "answer" : "74", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Complete the number sentence: ", "answer" : "43", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Complete the number sentence: ", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Emile is counting up in tens from 17. Which number will Emile say?", "answer" : "37|46|55", "type": 1, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Aimee has 60 gems. The gems are either blue or red. If Aimee has 32 blue gems, how many red gems does Aimee have?", "answer" : "28", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Autumn.push({ "question" : "Aimee has 60 gems. Emile has 17 more gems than Aimee. How many gems does Emile have? ", "answer" : "77", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Autumn.push({ "question" : "Aimee has 60 gems. Scrambler steals 12 gems. How many gems does Aimee need to have 100 gems? ", "answer" : "52", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Autumn.push({ "question" : "Scrambler has 5 red gems, 5 blue gems, 5 green gems, 5 purple gems and 7 pink gems. How many gems does Scrambler have? ", "answer" : "27", "type": 0, "units" : "gems", "marks" : 1})
questionsY3Autumn.push({ "question" : "Complete the part whole model. ", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Complete the part whole model. ", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "What is the missing number?", "answer" : "18", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Aimee is using a number line. What number is at point A? ", "answer" : "350", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Gems come in boxes of 5 gems and 10 gems. Scrambler has 45 gems in total. He bought three boxes of 5 gems. How many boxes of 10 gems has Scrambler bought? ", "answer" : "3", "type": 0, "units" : "boxes", "marks" : 1})
questionsY3Autumn.push({ "question" : "What is the missing symbol? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "What is the missing symbol? ", "answer" : "=|>|<", "type": 1, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "1 less than 734 is? ", "answer" : "733", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "10 more than 536 is ? ", "answer" : "546", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "100 less than ? is 469", "answer" : "569", "type": 0, "units" : "", "marks" : 1})



  var questionsY4Autumn = [];
  questionsY4Autumn.push({ "question" : "Aimee has made a number on a number grid. What number has she made?", "answer" : "2405", "type": 0, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Scrambler has made a number. What number has he made? ", "answer" : "1202", "type": 0, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Emile has 160 gems. He uses 60 gems. How many does he have left? ", "answer" : "100", "type": 0, "units" : "gems", "marks" : 1})
questionsY4Autumn.push({ "question" : "Which number statement is false? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "If 731 + 179 = 910, which number statement is false? ", "answer" : "E|D|F", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "What is two hundred and seventy-three add four hundred and ninety-nine?", "answer" : "772", "type": 0, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "What symbol is missing? ", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Which part whole model is <b>wrong</b>? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "What is the missing number? ", "answer" : "150", "type": 0, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Emile has labelled a number on a number line A. What number is most likely to be A? ", "answer" : "3,746|3,988|3,546", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Aimee has labelled a number on a number line B. What number is B?", "answer" : "-3|-1|1", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "Here is an array. What multiplication fact does it represent? ", "answer" : "4 x 7|5 x 7|7 x 5", "type": 1, "units" : "", "marks" : 1})
questionsY4Autumn.push({ "question" : "What is the area of this shape? ", "answer" : "7", "type": 0, "units" : "cm²", "marks" : 1})
questionsY4Autumn.push({ "question" : "What is the perimeter of this shape? ", "answer" : "12", "type": 0, "units" : "cm", "marks" : 1})
questionsY4Autumn.push({ "question" : "Scrambler has £405. He spends £75 on blue gems and £30 on red gems. He then spends the remaining money equally on green, orange, purple and pink gems. How much does he spend on pink gems?", "answer" : "75", "type": 0, "units" : "£", "marks" : 1})



  var questionsY5Autumn = [];
  questionsY5Autumn.push({ "question" : "Gems can be bought in boxes with each box having 6 gems. How many gems are there in 7 boxes? ", "answer" : "42", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Autumn.push({ "question" : "Gems can be bought in boxes with each box having 6 gems. Scrambler wants 48 gems. How many boxes should he buy? ", "answer" : "8", "type": 0, "units" : "boxes", "marks" : 1})
questionsY5Autumn.push({ "question" : "Aimee has a £10 note. She uses the note to buy some gems. She is given the change shown. How much did the gems cost Aimee? ", "answer" : "8.66", "type": 0, "units" : "£", "marks" : 1})
questionsY5Autumn.push({ "question" : "Emile has made a number. What number has he made? ", "answer" : "127", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "If 6,000 + p + 30 + 4 = 6,434, what is p? ", "answer" : "400", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Emile has made a number on a place value grid. What number has he made? ", "answer" : "4532", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Aimee starts counting from 0 in 6's. Which numbers will she say? ", "answer" : "12, 18, 24, 30|12, 18, 25, 30|12, 18, 26, 30", "type": 1, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "One planet has 3,698 gems. Scrambler takes 172 gems but Emile returns 184 gems. How many gems does the planet have now? ", "answer" : "3710", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Autumn.push({ "question" : "Emile has 160 gems. He stores the gems in boxes with 10 gems in each box. Each box with 10 gems inside weighs 2kg. How much do all the boxes and gems weigh? ", "answer" : "32", "type": 0, "units" : "kg", "marks" : 1})
questionsY5Autumn.push({ "question" : "Scrambler and Aimee together have 198 gems. Aimee has twice as many gems as Scrambler. How many gems does Scrambler have? ", "answer" : "66", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Autumn.push({ "question" : "There are 45,986 gems on the planet Tortuga. All the gems on Tortuga are gold or silver. There are 6,926 more silver gems than gold gems. How many gold gems are on Tortuga? ", "answer" : "19530", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Autumn.push({ "question" : "Aimee has found some gems. She has made a table showing the colours and amount of each colour of gem. How many red and blue gems are there altogether? ", "answer" : "20", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Autumn.push({ "question" : "Which numbers are factors of 24?", "answer" : "2, 4, 6, 8, 12|2, 4, 6, 9, 12|2, 4, 6, 10, 12", "type": 1, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Aimee has been monitoring the engine temperature. When was the engine hottest?", "answer" : "4", "type": 0, "units" : "pm", "marks" : 1})
questionsY5Autumn.push({ "question" : "Aimee has been monitoring the engine temperature. What was the biggest difference between the hottest and coldest temperature of the engine?", "answer" : "1200", "type": 0, "units" : "°", "marks" : 1})
questionsY5Autumn.push({ "question" : "Scrambler and Aimee have made numbers. What is the difference between Aimee's and Scrambler's numbers? ", "answer" : "121", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "What is the perimeter of this shape?", "answer" : "14", "type": 0, "units" : "cm", "marks" : 1})
questionsY5Autumn.push({ "question" : "What is the area of this shape? ", "answer" : "11", "type": 0, "units" : "cm²", "marks" : 1})
questionsY5Autumn.push({ "question" : "Scrambler has placed the letter A on a number line. Which number could be represented by A?", "answer" : "7,562|756|6,578", "type": 1, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Below is a part-whole model. Using the information in this model, complete the number sentence: 175 - ? = 112", "answer" : "63", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "What is the sum of these two Roman Numerals: IV and IX", "answer" : "13", "type": 0, "units" : "", "marks" : 1})



  var questionsY6Autumn = [];
  questionsY6Autumn.push({ "question" : "3 + 6 x 4 = ", "answer" : "27", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Which number is biggest? ", "answer" : "Fifty thousand, two hundred and two|16,753|thirty thousand, nine hundred and nine", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Which number is even? ", "answer" : "Fifty thousand, two hundred and two|Thirteen hundred and ninety-seven|thirty thousand, nine hundred and nine", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Which number is a factor of 48? ", "answer" : "12|10|9", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Which number is a prime number? ", "answer" : "17|15|16", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What is 16,753 rounded to the nearest 100?", "answer" : "16800", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Aimee has made a table of all the gems on the planet Polygonia. How many gems in total are on the planet? ", "answer" : "11390", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Autumn.push({ "question" : "How many more blue gems than pink gems are there? ", "answer" : "1512", "type": 0, "units" : "red gems", "marks" : 1})
questionsY6Autumn.push({ "question" : "Aimee shares her gems between herself, Emile and Scrambler. They each receive 8 gems and there are 2 left over. How many gems are there altogether? ", "answer" : "26", "type": 0, "units" : "gems ", "marks" : 1})
questionsY6Autumn.push({ "question" : "3 red gems weigh the same as 2 blue gems. A red gem weighs 150g. How much does a blue gem weigh? ", "answer" : "225", "type": 0, "units" : "g", "marks" : 1})
questionsY6Autumn.push({ "question" : "Emile has some gems. Everyday he used 4 gems. After 4 days, he has 4/5 of the gems left. How many gems did Emile start with? ", "answer" : "96", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Autumn.push({ "question" : "If 700 + p + 5 = 735, what is p? ", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "If 700 + q + 15 = 735, what is q? ", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What sign is missing? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What sign is missing? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "Aimee has 66 gems. 22 red gems, 24 blue gems, 8 pink gems and 12 green gems. Scrambler steals a third of Aimee's gems. How many gems does AImee have left? ", "answer" : "44", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Autumn.push({ "question" : "How much of the shape is shaded? ", "answer" : "3/7", "type": 2, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What is the missing number to make the fractions equivalent? ", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What is the missing number to make the fractions equivalent? ", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "What is the area of the shape shown? ", "answer" : "13", "type": 0, "units" : "cm²", "marks" : 1})
questionsY6Autumn.push({ "question" : "What is the perimeter of the shape shown?", "answer" : "16", "type": 0, "units" : "cm", "marks" : 1})
questionsY6Autumn.push({ "question" : "Here is a point on a grid. What are the co-ordinates of point A? ", "answer" : "(-4,-7)|(4,7)|(-7.-4)", "type": 1, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "If point A moves 6 right and 9 up, what are its new co-ordinates? ", "answer" : "(2, 2)|(6,9)|(10,16)", "type": 1, "units" : "", "marks" : 1})


  

//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  var timer = -1;

  //SET TIMER BASED ON THESE
  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    //check what questions it is, checking year first will check terms later like Autumn etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Autumn);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Autumn);
    } else if (props.assessment_type[0] == "3"){
      timer = 2100;
      setQuestions(questionsY3Autumn);
    } else if (props.assessment_type[0] == "4"){
      timer = 3000;
      setQuestions(questionsY4Autumn);
    } else if (props.assessment_type[0] == "5"){
      timer = 3000;
      setQuestions(questionsY5Autumn);
    } else if (props.assessment_type[0] == "6"){
      timer = 3000;
      setQuestions(questionsY6Autumn);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1 || questions[i].type == 4){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        console.log("CHOICES");
        console.log(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  /*
  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 999;
  }*/

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
    

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARAutumnEnd";
    }else if (props.assessment_type[3] == "re"){
      requireString+= "/REAutumnEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    let choices = shuffledAnswers[questionNum];
    console.log(shuffledAnswers);
    console.log(choices);

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="extrascaling">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }  
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`